module.exports = __webpack_public_path__ + "img/fourwaves-light-sq.bc8c7b2.png";